(() => {

    const getMedia = () =>
        document.querySelector('media-gallery slideshow-slide[aria-hidden="false"] .product-media') ||
        document.querySelector('media-gallery slideshow-slide.is-active .product-media') ||
        document.querySelector('media-gallery .slideshow-slide.is-active .product-media') ||
        document.querySelector('media-gallery .media-gallery__grid .product-media') ||
        document.querySelector('media-gallery .product-media') ||
        document.querySelector('media-gallery .product__media') ||
        document.querySelector('media-gallery .product-gallery');

    let lastMedia = null;

    const moveBadges = () => {

        const media = getMedia();

        if (!media || media === lastMedia)
            return;

        const badges =
            document.querySelectorAll(
                '.product-page-badges'
            );

        if (!badges.length)
            return;

        lastMedia = media;

        media.style.position = 'relative';

        badges.forEach(badge => {

            if (badge.parentElement !== media) {
                media.appendChild(badge);
            }

            badge.classList.add('is-ready');

        });

    };

    moveBadges();

    document.addEventListener(
        'variant:change',
        moveBadges
    );

    document.addEventListener(
        'slideChanged',
        moveBadges
    );

    window.addEventListener(
        'resize',
        moveBadges
    );

    requestAnimationFrame(
        moveBadges
    );

})();